module.exports = __webpack_public_path__ + "img/PS24.8e16fba1.png";